// Shared constants for the Activity Log page

export const ACTIONS = [
  { value: 'CREATE', label: 'Create' },
  { value: 'UPDATE', label: 'Update' },
  { value: 'DELETE', label: 'Delete' },
  { value: 'APPROVE', label: 'Approve' },
  { value: 'SUBMIT', label: 'Submit' },
  { value: 'EXPORT', label: 'Export' },
  { value: 'RUN', label: 'Run' },
  { value: 'REGENERATE', label: 'Regenerate' },
  { value: 'COMMENT', label: 'Comment' },
  { value: 'RESOLVE', label: 'Resolve' },
  { value: 'CANCEL', label: 'Cancel' },
  { value: 'INVITE', label: 'Invite' },
  { value: 'DEACTIVATE', label: 'Deactivate' },
  { value: 'LOGIN', label: 'Login' },
  { value: 'LOGOUT', label: 'Logout' }
];

export const RESOURCE_TYPES = [
  { value: 'workflow', label: 'Workflow' },
  { value: 'period', label: 'Period' },
  { value: 'file', label: 'File' },
  { value: 'fund', label: 'Fund' },
  { value: 'report', label: 'Report' },
  { value: 'jurisdiction', label: 'Jurisdiction' },
  { value: 'national_code', label: 'National Code' },
  { value: 'prompt_message', label: 'Prompt Message' },
  { value: 'extraction', label: 'Extraction' },
  { value: 'transformation', label: 'Transformation' },
  { value: 'transformation_action', label: 'Transformation Action' },
  { value: 'automation', label: 'Automation' },
  { value: 'comment', label: 'Comment' },
  { value: 'user', label: 'User' },
  { value: 'approver', label: 'Approver' },
  { value: 'company', label: 'Company' }
];

export const STATUSES = [
  { value: 'SUCCEEDED', label: 'Succeeded' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'IN_PROGRESS', label: 'In Progress' }
];

export const STATUS_LABELS = {
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
  IN_PROGRESS: 'In Progress'
};

export const STATUS_COLORS = {
  SUCCEEDED: { bg: '#d1fae5', text: '#065f46', dot: '#059669' },
  FAILED: { bg: '#fef2f2', text: '#dc2626', dot: '#ef4444' },
  IN_PROGRESS: { bg: '#e7f5ff', text: '#1c7ed6', dot: '#228BE6' }
};

export const ACTION_COLORS = {
  CREATE: '#15803d', // green
  UPDATE: '#a16207', // amber
  DELETE: '#b91c1c', // red
  APPROVE: '#065f46', // emerald
  SUBMIT: '#6d28d9', // purple
  EXPORT: '#0369a1', // sky
  RUN: '#0369a1', // sky
  REGENERATE: '#0e7490', // cyan
  COMMENT: '#7c3aed', // violet
  RESOLVE: '#059669', // emerald
  CANCEL: '#c2410c', // orange
  INVITE: '#86198f', // fuchsia
  DEACTIVATE: '#b91c1c', // red
  LOGIN: '#166534', // green
  LOGOUT: '#374151', // grey
  default: '#374151' // fallback
};

export const ACTION_LABELS = {
  CREATE: 'Create',
  UPDATE: 'Update',
  DELETE: 'Delete',
  APPROVE: 'Approve',
  SUBMIT: 'Submit',
  EXPORT: 'Export',
  RUN: 'Run',
  REGENERATE: 'Regenerate',
  COMMENT: 'Comment',
  RESOLVE: 'Resolve',
  CANCEL: 'Cancel',
  INVITE: 'Invite',
  DEACTIVATE: 'Deactivate',
  LOGIN: 'Login',
  LOGOUT: 'Logout'
};

export const RESOURCE_TYPE_LABELS = Object.fromEntries(
  RESOURCE_TYPES.map(({ value, label }) => [value, label])
);
